import "./Home.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import PremiumConstructionSolutionsHero from "./sections/PremiumConstructionSolutionsHero";
import OperationalExcellenceTrustBar from "./sections/OperationalExcellenceTrustBar";
import WhyChooseSwissSolutions from "./sections/WhyChooseSwissSolutions";
import EuropeanDistributionNetwork from "./sections/EuropeanDistributionNetwork";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainIndustrialHeader />
      <PremiumConstructionSolutionsHero />
      <OperationalExcellenceTrustBar />
      <WhyChooseSwissSolutions />
      <EuropeanDistributionNetwork />
      <IndustrialFooter />
    </div>;
}